import { iframeDataBridge } from '@/iframe/iframeDataBridge';

/**
 * Checks if the Sales Force Automation (SFA) module is activated.
 * @returns {boolean} True if SFA is activated, false otherwise.
 */
export function hasSFA() {
	const salesHelper = iframeDataBridge.getSalesHelper();
	return salesHelper && typeof salesHelper.isSFAActivated === 'function' ? salesHelper.isSFAActivated() : false;
}
